// extracted by mini-css-extract-plugin
export default {"modal":"WYtNgwbDL8koyYy2vD2F"};